import { render } from "./GiftStatus.vue?vue&type=template&id=2a600df4&scoped=true"
import script from "./GiftStatus.vue?vue&type=script&lang=js"
export * from "./GiftStatus.vue?vue&type=script&lang=js"

import "./GiftStatus.vue?vue&type=style&index=0&id=2a600df4&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a600df4"]])

export default __exports__